
import { Injectable } from "@angular/core";
import { VernostServiceService } from "./vernost-service.service";
import { Constants } from "../pages/master/test.constants";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class CsvUploadService {
  csvRecords = [];
  arr;
  fileImportInput: any;
  parent_table = "";
  constructor(
    private vernostService: VernostServiceService,
    private toastr: ToastrService
  ) {}

  fileChangeListen($event, parent_table): void {
    // var text = [];
    this.parent_table = parent_table;
    var target = $event.target || $event.srcElement;
    var files = target.files;
    // console.log("files", files);
    if (Constants.validateHeaderAndRecordLengthFlag) {
      if (!this.vernostService.isCSVFile(files[0])) {
        // alert("Please import valid .csv file.");
        this.toastr.error("Please import valid .csv file");
        // this.fileReset();
      }
    }

    var input = $event.target;
    var reader = new FileReader();
    reader.readAsText(input.files[0]);

    reader.onload = data => {
      var csvData :any;
      csvData = reader.result;
      // var arr="";
      // var csvdata=[csvData,arr];
      var csvRecordsArray = csvData.split(/\r\n|\n/);
      // var csvRecordsArray = csvdata[0].split(/\r\n|\n/);

      var headerLength = -1;
      if (Constants.isHeaderPresentFlag) {
        var headersRow = this.vernostService.getHeaderArray(
          csvRecordsArray,
          Constants.tokenDelimeter
        );
        headerLength = headersRow.length;
      }

      this.csvRecords = this.vernostService.getDataRecordsArrayFromCSVFile(
        csvRecordsArray,
        headerLength,
        Constants.validateHeaderAndRecordLengthFlag,
        Constants.tokenDelimeter
      );
      // alert(this.csvRecords)
      this.arr = {
        csvrecord: this.csvRecords,
        parent_table: this.parent_table
      };
      //alert("service,=" + JSON.stringify(this.arr));

      if (this.parent_table != "mst_currency_exchange_upload") {
        if (this.parent_table == "mst_user") {
          this.vernostService.insertUserTemp(this.arr).subscribe(response => {
            if (response[0].status == "Sucess") {
              // alert(response[0].message);
              this.toastr.success("Record Successfully Uploaded");
              //  console.log(JSON.stringify(response[0].status));
            } else {
              // alert("Failed to Insert!");
              this.toastr.error("Failed to Insert!");
              // console.log(JSON.stringify(response[0].status));
            }
          });
        } else {
          this.vernostService.insertCsvData(this.arr).subscribe(response => {
            if (response[0].status == "Sucess") {
              //alert(response[0].message);
              this.toastr.success("Record Successfully Uploaded");
            } else {
              //alert("Failed to Insert!");
              this.toastr.error("Failed to Insert!");
              // console.log(JSON.stringify(response[0].addinfo));
            }
          });
        }
        // console.log(this.csvRecords);

        if (this.csvRecords == null) {
          // If contains error, reset file.
          // this.fileReset();
        }
      }
    };

    reader.onerror = function() {
      //alert("Unable to read " + input.files[0]);
    };
  }

  // fileReset(){
  //   this.fileImportInput.nativeElement.value = "";
  //   this.csvRecords = [];
  // }

  getDataForUpload() {
    return this.arr;
  }
}